import PropTypes from 'prop-types';

const propTypes = {
	value: PropTypes.string,
};

export default propTypes;
